/* HC Packaging Plus: slideshow and tabbed product carousel for hc-* sections. */
(() => {
  if (customElements.get('hc-slideshow')) return;

  class HcSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.hc-slide')];
      this.dots = [...this.querySelectorAll('.hc-slides__dot')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    start() {
      const seconds = Number(this.dataset.autoplay || 0);
      if (!seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
    }
    stop() { clearInterval(this.timer); }
    go(i, user) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.classList.toggle('is-active', on);
        s.toggleAttribute('inert', !on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.index ? 'true' : 'false'));
      if (user) this.start();
    }
  }
  customElements.define('hc-slideshow', HcSlideshow);

  class HcProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.scroll(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.scroll(1));
    }
    get track() { return this.panels.find((p) => !p.hidden)?.querySelector('.hc-ptabs__track'); }
    select(i) {
      this.tabs.forEach((t, k) => {
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        t.tabIndex = k === i ? 0 : -1;
      });
      this.panels.forEach((p, k) => (p.hidden = k !== i));
      const viewAll = this.querySelector('[data-view-all]');
      if (viewAll && this.tabs[i].dataset.url) viewAll.href = this.tabs[i].dataset.url;
    }
    scroll(dir) {
      const track = this.track;
      if (!track) return;
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }
  }
  customElements.define('hc-product-tabs', HcProductTabs);
})();
